import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { showHistoryLogs } from './actions';
import ProgressBar from '../progress-bar';

import LogPopover from '../../modules/Forecast/components/opportunity-table/popover';
import {
  getLoading,
  getLoaded,
  getLogs,
  getCurrentOpportunity,
  getCurrentLogType,
} from './reducer';

class HistoryLogModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.close = this.close.bind(this);
  }

  close() {
    this.props.dispatch(showHistoryLogs(null, null));
  }

  getTitle() {
    const { type } = this.props;
    let t = '';
    switch (type) {
      case 'amount':
        t = 'Amount History';
        break;
      case 'close_date':
        t = 'Close Date History';
        break;
      case 'stage_name':
        t = 'Stage History';
        break;
      case 'forecast_category_name':
        t = 'Forecast Category History';
        break;
      default:
        t = '';
    }
    return t;
  }

  render() {
    const {
      opportunity, type, logs, loaded, loading,
    } = this.props;
    const total = logs.length;
    const show = opportunity !== null;
    const title = opportunity ? `${opportunity.name}: ${this.getTitle()}` : 'History Logs';

    return (
      <Modal key="modal" show={show} onExited={this.close}>
        <Modal.Header closeButton>
          <h4>{title}</h4>
        </Modal.Header>
        <Modal.Body>
          {loading && <p><ProgressBar /></p>}
          {!loading && type !== null &&
            <div style={{ maxHeight: 400, overflowX: 'hidden', overflowY: 'auto' }}>
              <LogPopover
                noWrapper
                type={type}
                logs={logs}
                enter
                loaded={loaded}
                total={total}
              />
            </div>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.close} bsStyle="default">
            Done
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
function mapStateToProps(state) {
  const opportunity = getCurrentOpportunity(state);
  const type = getCurrentLogType(state);
  const opportunityId = opportunity ? opportunity.opportunity_id : null;
  return {
    opportunity,
    type,
    loaded: opportunityId ? getLoaded(state, opportunityId) : false,
    loading: opportunityId ? getLoading(state, opportunityId) : false,
    logs: opportunityId ? getLogs(state, opportunityId, type) : [],
  };
}
HistoryLogModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  opportunity: PropTypes.shape({
    opportunity_id: PropTypes.string.isRequired,
  }),
  type: PropTypes.string,
  loaded: PropTypes.bool,
  loading: PropTypes.bool,
  logs: PropTypes.arrayOf(PropTypes.shape({})),
};

HistoryLogModal.defaultProps = {
  loaded: false,
  loading: false,
  opportunity: null,
  type: null,
  logs: [],
};

export default connect(mapStateToProps)(HistoryLogModal);
